module.exports = __webpack_public_path__ + "img/red-warning-triangle.14da3b69.svg";